import type { AdBreakData, AdData } from './index.h'

/**
 * Convert milliseconds to seconds
 */
const getSecondsFromMilliseconds = (milliseconds: number): number => {
  return Math.floor(milliseconds / 1000)
}

/**
 * Format ad data from SmartLib (convert milliseconds to seconds)
 */
export const formatAdData = (adData: AdData): AdData => {
  return {
    ...adData,
    duration: getSecondsFromMilliseconds(adData.duration),
    skipPosition: getSecondsFromMilliseconds(adData.skipPosition),
    startPosition: getSecondsFromMilliseconds(adData.startPosition),
  }
}

/**
 * Format ad break data from SmartLib (convert milliseconds to seconds)
 */
export const formatAdBreakData = (adBreakData: AdBreakData): AdBreakData => {
  return {
    ...adBreakData,
    ads: adBreakData.ads.map(formatAdData),
    duration: getSecondsFromMilliseconds(adBreakData.duration),
  }
}
